import styled from "styled-components";

const Heading = styled.h1`
    font-size:3rem;
    text-align:center;
    padding: 1rem;
    color: #f8c476;
    height: 3rem;
    margin: 0;
    position: absolute;
    top: 40%;
    z-index: 99;
    text-shadow: 2px 2px 2px #000000;

`

export{Heading}